import React, { useState } from 'react';

const overColor = 'red';
const PickSqCheckBox = ({ value = false, onClick = () => {}, disabled = false, id = '', name = '' }) => {
  const [over, setOver] = useState(false);
  return value
    ? (
      <svg
        style={{ cursor: disabled ? 'default' : 'pointer', margin: 1 }}
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={disabled ? null : () => onClick(id, name)}
        onMouseOver={disabled ? null : () => setOver(true)}
        onMouseOut={disabled ? null : () => setOver(false)}
      >
        <rect width="15" height="15" rx="2" fill={over ? overColor : '#5A397E'} />
        <path fillRule="evenodd" clipRule="evenodd" d="M11.1583 4.3423C11.2704 4.22478 11.3993 4.16602 11.5451 4.16602C11.6909 4.16602 11.8198 4.22478 11.932 4.3423C12.0329 4.44807 12.0833 4.58028 12.0833 4.73893C12.0833 4.89759 12.0329 5.0298 11.932 5.13557L6.56652 10.7942C6.55531 10.806 6.54409 10.8177 6.53288 10.8295C6.52167 10.8412 6.51045 10.853 6.49924 10.8647C6.39832 10.9823 6.27218 11.041 6.1208 11.041C5.96942 11.041 5.84328 10.9823 5.74236 10.8647L3.06805 8.07948C2.96713 7.97371 2.91667 7.8415 2.91667 7.68284C2.91667 7.52419 2.96713 7.39198 3.06805 7.28621C3.18018 7.16869 3.30913 7.10993 3.4549 7.10993C3.60067 7.10993 3.72962 7.16869 3.84175 7.28621L6.11239 9.66602L11.1583 4.3423Z" fill="white" />
      </svg>
    )
    : (
      <svg
        style={{ cursor: disabled ? 'default' : 'pointer' }}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={disabled ? null : () => onClick(id, name)}
        onMouseOver={disabled ? null : () => setOver(true)}
        onMouseOut={disabled ? null : () => setOver(false)}
      >
        <rect x="1" y="1" width="15" height="15" rx="2" stroke={over ? overColor : '#5A397E'} />
        <path fillRule="evenodd" clipRule="evenodd" d="M12.1583 5.3423C12.2704 5.22478 12.3993 5.16602 12.5451 5.16602C12.6909 5.16602 12.8198 5.22478 12.932 5.3423C13.0329 5.44807 13.0833 5.58028 13.0833 5.73893C13.0833 5.89759 13.0329 6.0298 12.932 6.13557L7.56652 11.7942C7.55531 11.806 7.54409 11.8177 7.53288 11.8295C7.52167 11.8412 7.51045 11.853 7.49924 11.8647C7.39832 11.9823 7.27218 12.041 7.1208 12.041C6.96942 12.041 6.84328 11.9823 6.74236 11.8647L4.06805 9.07948C3.96713 8.97371 3.91667 8.8415 3.91667 8.68284C3.91667 8.52419 3.96713 8.39198 4.06805 8.28621C4.18018 8.16869 4.30913 8.10993 4.4549 8.10993C4.60067 8.10993 4.72962 8.16869 4.84175 8.28621L7.11239 10.666L12.1583 5.3423Z" fill="transparent" />
      </svg>
    );
};
// const App = (props = { value: false, onClick: () => {}, disabled: false }) => <CircleCheckBox {...props} />;
export default PickSqCheckBox;
